import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetch } from '../../../services/transports';
import { searchDrug } from '../../../api/drug';
import { searchAlternativeDrug } from '../../../api/demandAndOffer';
import { notificationTypes } from '../../../constants';
import { LabeledSelect, showNotification } from '..';

export const SearchDrugs = ({
  label,
  id,
  onChange,
  withAsterisks,
  gtin,
  setValueAsObject,
  drugIdForAlternative = null,
  isRecalOrBlockNotification = false,
  onlyActive = false,
  setData,
  placeholder,

  ...props }) => {

  const [ drugsOptions, setDrugsOptions ] = useState([]);
  const [ search, setSearch ] = useState();


  const [ { isSuccess }, fetchSearchDrugs ] = useFetch(drugIdForAlternative ? searchAlternativeDrug : searchDrug,
    useCallback(response => {
      const options = response?.data?.slice().map(item => ({
        value: isRecalOrBlockNotification ? `${item.gtin}` : `${item.id}`,
        text: `${item.gtin} - ${item.name}`,
        item
      }));
      setDrugsOptions(options);
      if (setData) { setData(response?.data); }
    }));


  const onSearchDrug = useCallback(query => {
    setSearch({
      ...(drugIdForAlternative
        ? { drugId: drugIdForAlternative, nameOrGtin: query?.trim() ?? null, inCurrentStakeholder: true }
        : { query: query?.trim() ?? null, onlyActive })
    });
  }, [ fetchSearchDrugs ]);

  const [ t ] = useTranslation();


  useEffect(() => {
    const options = [];
    if (gtin || drugIdForAlternative) {

      setSearch({
        ...(drugIdForAlternative ? { drugId: drugIdForAlternative, inCurrentStakeholder: true } : {}),
        query: gtin
      });
    }
    setDrugsOptions(options);
  }, [ gtin ]);

  useEffect(() => {
    if (search) {
      fetchSearchDrugs(search);
    }
  }, [ search ]);

  return (
    <LabeledSelect
      data-testid={ id }
      setValueAsObject={ setValueAsObject }
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      withDebounceSearch={ true }
      onSearch={ onSearchDrug }
      searchDelay={ 1000 }
      options={ drugsOptions }
      filterOption={ false }
      EmptyComponent={ t('ERR.noMatchedDrug') }
      withAsterisks={ withAsterisks }
      placeholder={ placeholder ? placeholder : t('fields.drug.search') }
      // value={ drugsOptions?.value || undefined }
      value={ id }
      { ...props }
    />
  );
};
